export default "__VITE_ASSET__BFnN4Ypj__"